import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import Jsona from 'jsona';
import { map } from 'rxjs';
import { JSONAPIContentType } from '../shared/jsonapi';

export function JSONAPIInterceptor(req: HttpRequest<any>, next: HttpHandlerFn) {
  const jsonapi = inject(Jsona);

  return next(req).pipe(
    map((event: HttpEvent<any>) => {
      if (!(event instanceof HttpResponse)) {
        return event;
      }

      if (req.headers.get('Accept') !== JSONAPIContentType) {
        return event;
      }

      const contentType = event.headers.get('Content-Type');

      if (!contentType?.includes(JSONAPIContentType)) {
        return event;
      }

      return event.clone({ body: jsonapi.deserialize(event.body) });
    })
  );
}
